module.exports = __webpack_public_path__ + "img/hardyArms2.627365fd.png";